/**
 * ACF filter to stop escaping select2 markup in the admin.
 */

jQuery( $ => { // eslint-disable-line no-unused-vars
	acf.add_filter( 'select2_escape_markup', function( escapedValue, originalValue, $select, settings, field, instance ) { // eslint-disable-line no-undef, no-unused-vars
		// return the unescaped values because we don't want the markup to be escaped.
		return originalValue;
	} );
} );
